import "./frontend.scss"
import React, { useState } from "react"
import ReactDOM from "react-dom/client"
import App from "./App"

const divsToUpdate = document.querySelectorAll(".react-root")

divsToUpdate.forEach(div => {
  const data = JSON.parse(div.querySelector("pre").innerText)
  const root = ReactDOM.createRoot(div)
  root.render(<FrontEndComponent {...data} />)
  div.classList.remove("react-root")
})

function FrontEndComponent(props) {
  return (
    <div>
      <App/>
    </div>
  )
}
